import React from 'react';
import './TrackingSection.css';
import { FaBitcoin, FaEthereum, FaChartLine, FaBell } from 'react-icons/fa';
import trackingImage from '../assets/tracking-image-v2.png'; // Bu resmi assets klasörüne ekleyin

const TrackingSection = () => {
  const cryptoData = [
    { name: 'Bitcoin', symbol: 'BTC', price: '$48,235.65', change: '+2.4%', icon: <FaBitcoin /> },
    { name: 'Ethereum', symbol: 'ETH', price: '$3,278.12', change: '+1.8%', icon: <FaEthereum /> },
    { name: 'Cardano', symbol: 'ADA', price: '$0.523', change: '-0.6%', icon: 'ADA' },
    { name: 'Solana', symbol: 'SOL', price: '$142.87', change: '+5.2%', icon: 'SOL' },
  ];

  return (
    <section id="tracking" className="section tracking-section">
      <div className="container">
        <h2 className="section-title" data-aos="fade-up">
          Kripto Piyasası <span className="gradient-text">Parmaklarınızın Ucunda</span>
        </h2>
        <p className="section-description" data-aos="fade-up" data-aos-delay="100">
          Gerçek zamanlı fiyat takibi, grafikler ve piyasa analizleri ile kripto varlıklarınızı 
          en verimli şekilde yönetin.
        </p>
        
        <div className="tracking-grid">
          <div className="tracking-content" data-aos="fade-right">
            <div className="crypto-cards">
              {cryptoData.map((crypto, index) => (
                <div 
                  className="crypto-card" 
                  key={index}
                  data-aos="fade-up" 
                  data-aos-delay={100 + (index * 100)}
                >
                  <div className="crypto-icon">
                    {typeof crypto.icon === 'string' ? crypto.icon : crypto.icon}
                  </div>
                  <div className="crypto-info">
                    <h3>{crypto.name} <span>{crypto.symbol}</span></h3>
                    <p className="crypto-price">{crypto.price}</p>
                  </div>
                  <div className={`crypto-change ${crypto.change.includes('-') ? 'negative' : 'positive'}`}>
                    {crypto.change}
                  </div>
                </div>
              ))}
            </div>
            
            <div className="tracking-features" data-aos="fade-up">
              <div className="tracking-feature">
                <div className="tracking-feature-icon">
                  <FaChartLine />
                </div>
                <div className="tracking-feature-content">
                  <h3>Gelişmiş Grafikler</h3>
                  <p>İleri düzey teknik analiz araçları ve göstergelerle piyasayı derinlemesine analiz edin.</p>
                </div>
              </div>
              
              <div className="tracking-feature">
                <div className="tracking-feature-icon">
                  <FaBell />
                </div>
                <div className="tracking-feature-content">
                  <h3>Fiyat Alarmları</h3>
                  <p>Özel alarmlar oluşturun ve fırsatları kaçırmayın. Fiyat hareketlerinden anında haberdar olun.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="tracking-image" data-aos="fade-left" data-aos-delay="200">
            <img src={trackingImage} alt="CTO Tracking Interface" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrackingSection; 